module.exports = __webpack_public_path__ + "static/media/olin_interno.5ec05aa0.png";